import { Box, Stack, useTheme } from "@mui/material";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { Formaters } from "lib/Formaters";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { RootPaths } from "routes/RootRouter";
import { StickerBox } from "views/knowledge/components/card/behaviors/common/StickerBox";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

///
export const TitleDialog = () => {
    const { otherInfo, pub, pub: { expired, availableInTheFuture } } = useCardContext();
    const theme = useTheme();
    const { t } = useTranslation("knowledge");

    const isBlocked = pub.blocked?.blockedOn != undefined;

    const color = isBlocked
        ? theme.palette.warning.main
        : expired || availableInTheFuture
            ? theme.palette.muted.light
            : undefined;

    var borderStyle: React.CSSProperties | undefined = (pub.interaction.isNewPublication || pub.blocked?.firstAccessAfterBlock === true || pub.rejected?.firstAccessAfterRejected === true)
        ? { borderLeft: "4px solid", borderLeftColor: theme.palette.warning.main, paddingLeft: theme.spacing(1) }
        : undefined;

    var RenderTitle = (
        <MprcFeedTypography variant="title" component="div" noWrap={true} color={"inherit"}>
            <span title={pub.title}>{pub.title}</span>
        </MprcFeedTypography>
    );

    return (
        <div style={borderStyle}>

            <Box sx={{ color: color }}>
                {
                    otherInfo.enableTitleLink === false
                        ? RenderTitle
                        : (
                            <Link
                                onClick={otherInfo?.onBeforeLinkClick == undefined ? undefined : otherInfo.onBeforeLinkClick()}
                                to={RootPaths.BuildUserProfile(pub.author.userId)}
                            >
                                {RenderTitle}
                            </Link>
                        )
                }
            </Box>

            <Stack spacing={0.5} alignItems="flex-end" direction="row">
                {isBlocked && <StickerBox name={t("Feed.Card.Common.BlockedText")} textColor={theme.palette.common.white} backgroundColor={theme.palette.warning.main} />}
                {expired && <StickerBox name={t("Feed.Card.Common.ExpiredText")} textColor={theme.palette.common.white} backgroundColor={theme.palette.muted.light} />}
                {availableInTheFuture && <StickerBox name={t("Feed.Card.Common.DisplayOnText", { date: Formaters.dayMonth(pub.viewPeriodStart) })} textColor={theme.palette.common.white} backgroundColor={theme.palette.muted.light} />}
                {pub.sticker && <StickerBox name={pub.sticker.name} textColor={pub.sticker.textColor} backgroundColor={pub.sticker.backgroundColor} />}
            </Stack>
        </div>
    );
};
